import { InvoiceStatus } from '#types';

/* if we don't have a status and there's no id in the URL then return true
If we don't have a status and there IS an ID in the URL then we're just waiting for the context to get updated, so false
...one of the downsides of not using props in components is sometimes waiting...
*/
export const lineItemsAreMutable = (
	invoiceExists: boolean,
	status?: InvoiceStatus
) =>
	status
		? ![
			InvoiceStatus.Disputed,
			InvoiceStatus.Void,
			InvoiceStatus.Hidden,
		  ].includes( status )
		: !invoiceExists;
